import React from 'react';
import PropTypes from 'prop-types';

const PeopleDistanceIcon = ({ className = '', ...props }) => (
  <svg
    fill="currentColor"
    width="800px"
    height="800px"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path d="M12.1,12A5,5,0,1,0,7,7.1,5,5,0,0,0,12.1,12Z" />
    <path d="M16,36a2,2,0,0,0-2,2v4H10V32H6V20a2,2,0,0,1,2-2h6a2,2,0,0,0,0-4H8a6,6,0,0,0-6,6V33a2.9,2.9,0,0,0,3,3H6v7a2.9,2.9,0,0,0,3,3h6a2.9,2.9,0,0,0,3-3V38A2,2,0,0,0,16,36Z" />
    <path d="M36.1,12A5,5,0,1,0,31,7.1,5,5,0,0,0,36.1,12Z" />
    <path d="M40,14H33a2,2,0,0,0,0,4h7a2,2,0,0,1,2,2V32H38V42H34V38a2,2,0,0,0-4,0v5a2.9,2.9,0,0,0,3,3h6a2.9,2.9,0,0,0,3-3V36h1a2.9,2.9,0,0,0,3-3V20A6,6,0,0,0,40,14Z" />
    <path d="M31.4,33.4,37.8,27l-6.4-6.4a2,2,0,0,0-2.8,2.8L30.2,25H17.8l1.6-1.6a2,2,0,0,0-2.8-2.8L10.2,27l6.4,6.4a1.9,1.9,0,0,0,2.8,0,1.9,1.9,0,0,0,0-2.8L17.8,29H30.2l-1.6,1.6a1.9,1.9,0,0,0,0,2.8,1.9,1.9,0,0,0,2.8,0Z" />
  </svg>
);

PeopleDistanceIcon.propTypes = {
  className: PropTypes.string,
};

export default PeopleDistanceIcon;
